import { environmentsId, type EnvironmentsId } from "./Environments";
import { templatesId, type TemplatesId } from "./Templates";
import { templateContentsId, type TemplateContentsId } from "./TemplateContents";
import type { ColumnType, Selectable, Insertable, Updateable } from "kysely";
import { z } from "zod";

/** Identifier type for environment_template_states */
export type EnvironmentTemplateStatesId = string & { __flavor: "EnvironmentTemplateStatesId" };

/**
 * Represents the table public.environment_template_states
 * @uniqueConstraints {"environment_template_states_pkey":{"name":"environment_template_states_pkey","isPrimary":true,"isUnique":true,"columns":[{"name":"id","definition":"id","predicate":null}]},"env_template_state_unique":{"name":"env_template_state_unique","isPrimary":false,"isUnique":true,"columns":[{"name":"environment_id","definition":"environment_id","predicate":null},{"name":"template_id","definition":"template_id","predicate":null}]}}
 */
export default interface EnvironmentTemplateStatesTable {
  id: ColumnType<
    EnvironmentTemplateStatesId,
    EnvironmentTemplateStatesId | undefined,
    EnvironmentTemplateStatesId
  >;

  environmentId: ColumnType<EnvironmentsId, EnvironmentsId, EnvironmentsId>;

  templateId: ColumnType<TemplatesId, TemplatesId, TemplatesId>;

  activeContentId: ColumnType<TemplateContentsId, TemplateContentsId, TemplateContentsId>;

  lastUpdatedAt: ColumnType<Date, Date | string | undefined, Date | string>;
}

export type EnvironmentTemplateStates = Selectable<EnvironmentTemplateStatesTable>;

export type NewEnvironmentTemplateStates = Insertable<EnvironmentTemplateStatesTable>;

export type EnvironmentTemplateStatesUpdate = Updateable<EnvironmentTemplateStatesTable>;

export const environmentTemplateStatesId =
  z.string() as unknown as z.Schema<EnvironmentTemplateStatesId>;

export const environmentTemplateStates = z.object({
  id: environmentTemplateStatesId,
  environmentId: environmentsId,
  templateId: templatesId,
  activeContentId: templateContentsId,
  lastUpdatedAt: z.date(),
});

export const environmentTemplateStatesInitializer = z.object({
  id: environmentTemplateStatesId.optional(),
  environmentId: environmentsId,
  templateId: templatesId,
  activeContentId: templateContentsId,
  lastUpdatedAt: z.date().optional(),
});

export const environmentTemplateStatesMutator = z.object({
  id: environmentTemplateStatesId.optional(),
  environmentId: environmentsId.optional(),
  templateId: templatesId.optional(),
  activeContentId: templateContentsId.optional(),
  lastUpdatedAt: z.date().optional(),
});

// ── constraints for EnvironmentTemplateStates ─────────────────────────────────
export const EnvironmentTemplateStatesConstraints = {
  environment_template_states_pkey: {
    name: "environment_template_states_pkey",
    isPrimary: true,
    isUnique: true,
    columns: [{ name: "id", definition: "id", predicate: null }],
  },
  env_template_state_unique: {
    name: "env_template_state_unique",
    isPrimary: false,
    isUnique: true,
    columns: [
      { name: "environment_id", definition: "environment_id", predicate: null },
      { name: "template_id", definition: "template_id", predicate: null },
    ],
  },
} as const;
export type EnvironmentTemplateStatesConstraintsType = typeof EnvironmentTemplateStatesConstraints;
